import makeRequestUrl from './url.js';

module.exports = prefix => {
    const domain = `//${prefix}-pyp-api.chuxingyouhui.com/api`;
    // const domain = '//127.0.0.1:7300/mock/5d413edb27707b566babb75a/api';
    // const blackCardDomain = window.location.origin;
    const blackCardDomain = `//${prefix}-m.black-unique.com`;
    const fanxianDomain = `//${prefix}-fanxian-api.chuxingyouhui.com`;
    const lbsDomain = '//lbs.chuxingyouhui.com/api';
    const marketingDomain = `//${prefix}-market.chuxingyouhui.com/promo-bargain-api`;
    const jsonConfigDomain = '//h5.chuxingyouhui.com/yunying/config/devJson';
    const privilegeApiDomain = `//${prefix}-privilege-api.black-unique.com`;
    const privilegeDomain = `//${prefix}-privilege-api.black-unique.com`;
    const vipMemberDomain = `//${prefix}-vip-member.chuxingyouhui.com`;
    const orderDomain = `//${prefix}-union-order-api.chuxingyouhui.com`;
    const annualDomain = `//${prefix}-annual-summary-api.chuxingyouhui.com`;
    const facadeDomain = `//${prefix}-facade-api.black-unique.com`;
    const adsDomain = `//${prefix}-advertise-api.black-unique.com`;
    const cardDomain = `//${prefix}-card-api.black-unique.com`;
    const sbtsDomain = `//${prefix}-sbts-api.chuxingyouhui.com`;
    const wechatDomain = `//${prefix}-wechat-api.black-unique.com`;
    const giftCardDomain = `//${prefix}-gift-card-api.black-unique.com`;
    const areaDomain = `//${prefix}-area.chuxingyouhui.com`;

    const api = makeRequestUrl({
        blackCardDomain,
        domain,
        lbsDomain,
        jsonConfigDomain,
        marketingDomain,
        fanxianDomain,
        privilegeDomain,
        privilegeApiDomain,
        vipMemberDomain,
        facadeDomain,
        adsDomain,
        cardDomain,
        sbtsDomain,
        wechatDomain,
        giftCardDomain,
        areaDomain,
    });

    exports.domain = domain;
    exports.api = api;
    exports.blackCardDomain = blackCardDomain;
    exports.fanxianDomain = fanxianDomain;
    exports.privilegeDomain = privilegeDomain;
    exports.lbsDomain = lbsDomain;
    exports.marketingDomain = marketingDomain;
    exports.vipMemberDomain = vipMemberDomain;
    exports.privilegeDomain = privilegeDomain;
    exports.orderDomain = orderDomain;

    exports.privilegeApiDomain = privilegeApiDomain;
    exports.annualDomain = annualDomain;
    exports.facadeDomain = facadeDomain;
    exports.adsDomain = adsDomain;
    exports.cardDomain = cardDomain;
    exports.sbtsDomain = sbtsDomain;
    exports.wechatDomain = wechatDomain;
    exports.giftCardDomain = giftCardDomain;
    // 环境类型标识
    exports.envType = 'box';
    exports.envPrefix = prefix;

    // app下载链接
    exports.appDownloadUrl = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.black.unique';

    return exports;
};
